import { FacebookWebSignIn } from './facebook_web_sign_in.js';

const { FacebookSignIn } = ( window as any ).Capacitor?.Plugins ?? {};
const isNative = !!FacebookSignIn;

export const FacebookSignInPlugin = {
  isAvailable(): boolean
  {
    return isNative || FacebookWebSignIn.isAvailable();
  },

  getCachedId(): Promise<string | null>
  {
    if ( isNative ) return FacebookSignIn.getCachedId().then( ( r: { facebookId?: string } ) => r.facebookId ?? null );
    return Promise.resolve( FacebookWebSignIn.getCachedId() );
  },

  setCachedId( id: string ): void
  {
    FacebookWebSignIn.setCachedId( id );
  },

  async signIn(): Promise<{ accessToken: string; userId: string; profileUrl?: string; pictureUrl?: string }>
  {
    if ( isNative ) return FacebookSignIn.signIn();
    return FacebookWebSignIn.signIn();
  },

  async signOut(): Promise<void>
  {
    if ( isNative )
    {
      await FacebookSignIn.signOut();
      return;
    }
    FacebookWebSignIn.signOut();
  },
};
